// src/pages/DeleteRequest.js
import { useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import PageHero from '../components/PageHero';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function DeleteRequest() {
  const [email, setEmail]   = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | already | error

  const handleSubmit = async () => {
    if (!EMAIL_RE.test(email.trim())) {
      alert('Kripya ek valid email address darj karein.');
      return;
    }

    setStatus('loading');
    try {
      const q = query(
        collection(db, 'deletion_requests'),
        where('email', '==', email.trim().toLowerCase())
      );
      const snap = await getDocs(q);

      if (!snap.empty) {
        setStatus('already');
        return;
      }

      await addDoc(collection(db, 'deletion_requests'), {
        email:       email.trim().toLowerCase(),
        requestedAt: serverTimestamp(),
        status:      'pending',
      });

      setStatus('success');
    } catch (err) {
      console.error('Deletion request error:', err);
      setStatus('error');
    }
  };

  return (
    <>
      <PageHero
        tag="Data Deletion · डेटा हटाएं"
        title="Request Account Deletion"
        subtitle="अपना डेटा हटाने का अनुरोध यहाँ भेजें।"
        from="#102844"
        to="#1B3A5C"
        tagColor="rgba(255,255,255,.9)"
      />

      <section className="section section-gray">
        <div className="wrap" style={{ maxWidth: 680 }}>

          {status === 'success' && (
            <div style={card}>
              <div style={{ fontSize: 52, textAlign: 'center', marginBottom: 16 }}>✅</div>
              <h2 style={heading}>Request Received!</h2>
              <p style={body}>
                Aapka data deletion request successfully submit ho gaya hai.
              </p>
              <div style={infoBox}>
                <div style={infoRow}>
                  <span style={infoIcon}>📧</span>
                  <div>
                    <div style={infoLabel}>Email</div>
                    <div style={infoVal}>{email.trim().toLowerCase()}</div>
                  </div>
                </div>
                <div style={infoRow}>
                  <span style={infoIcon}>📅</span>
                  <div>
                    <div style={infoLabel}>Expected Deletion</div>
                    <div style={infoVal}>Within 7 business days</div>
                  </div>
                </div>
                <div style={{ ...infoRow, borderBottom: 'none' }}>
                  <span style={infoIcon}>🔔</span>
                  <div>
                    <div style={infoLabel}>Status</div>
                    <div style={{ ...infoVal, color: '#1F6E43', fontWeight: 700 }}>Pending Review</div>
                  </div>
                </div>
              </div>
              <p style={{ ...body, fontSize: 13, color: '#718096', marginTop: 16 }}>
                Koi sawal ho to hamse contact karein:{' '}
                <a href="mailto:yojanasaathi@gmail.com" style={{ color: '#102844' }}>
                  yojanasaathi@gmail.com
                </a>
              </p>
            </div>
          )}

          {status === 'already' && (
            <div style={card}>
              <div style={{ fontSize: 52, textAlign: 'center', marginBottom: 16 }}>ℹ️</div>
              <h2 style={heading}>Request Already Submitted</h2>
              <p style={body}>
                <strong>{email.trim().toLowerCase()}</strong> ke liye deletion request pehle se register hai.
              </p>
              <div style={infoBox}>
                <div style={{ ...infoRow, borderBottom: 'none' }}>
                  <span style={infoIcon}>⏳</span>
                  <div>
                    <div style={infoLabel}>Aapka data</div>
                    <div style={infoVal}>7 business days ke andar delete kar diya jaayega</div>
                  </div>
                </div>
              </div>
              <p style={{ ...body, fontSize: 13, color: '#718096', marginTop: 16 }}>
                Koi urgency ho to seedha email karein:{' '}
                <a href="mailto:yojanasaathi@gmail.com" style={{ color: '#102844' }}>
                  yojanasaathi@gmail.com
                </a>
              </p>
            </div>
          )}

          {(status === 'idle' || status === 'loading' || status === 'error') && (
            <div style={card}>
              <h2 style={heading}>Delete My Data</h2>
              <p style={body}>
                Apna registered email address darj karein. Hum aapka sabhi personal data 7 business days ke andar permanently delete kar denge.
              </p>

              <div style={{ marginTop: 8, marginBottom: 6 }}>
                <label style={labelStyle}>Email Address</label>
                <input
                  type="email"
                  placeholder="aapka@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  disabled={status === 'loading'}
                  style={inputStyle}
                  onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                />
              </div>

              {status === 'error' && (
                <p style={{ fontSize: 13, color: '#C0392B', margin: '6px 0 10px' }}>
                  Kuch galat hua. Dobara try karein ya seedha email karein: yojanasaathi@gmail.com
                </p>
              )}

              <button
                className="btn btn-navy btn-full"
                style={{ fontSize: 15, marginTop: 12 }}
                onClick={handleSubmit}
                disabled={status === 'loading'}
              >
                {status === 'loading' ? 'Submitting…' : 'Submit Deletion Request →'}
              </button>

              <div style={noteBox}>
                <ul style={{ margin: 0, paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 7 }}>
                  <li style={noteItem}>Aapka request submit hone ke baad aap isse cancel nahi kar sakte.</li>
                  <li style={noteItem}>7 business days ke andar aapka data permanently delete kar diya jaayega.</li>
                  <li style={noteItem}>Ek email se sirf ek request bhej sakte hain.</li>
                </ul>
              </div>
            </div>
          )}

        </div>
      </section>
    </>
  );
}

// ── Inline styles ────────────────────────────────────────────────
const card = {
  background: '#fff',
  border: '1px solid #DEE2E6',
  borderRadius: 14,
  padding: '40px 36px',
  boxShadow: '0 4px 24px rgba(0,0,0,.06)',
};

const heading = {
  fontFamily: 'Georgia, serif',
  fontSize: 26,
  color: '#102844',
  marginBottom: 10,
  textAlign: 'center',
};

const body = {
  fontSize: 15,
  lineHeight: 1.7,
  color: '#4A5568',
  textAlign: 'center',
  marginBottom: 20,
};

const infoBox = {
  background: '#F8F9FA',
  border: '1px solid #DEE2E6',
  borderRadius: 10,
  padding: '4px 18px',
  margin: '12px 0',
};

const infoRow = {
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  padding: '13px 0',
  borderBottom: '1px solid #DEE2E6',
};

const infoIcon = { fontSize: 22 };

const infoLabel = {
  fontSize: 11.5,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '.06em',
  color: '#718096',
  marginBottom: 2,
};

const infoVal = { fontSize: 14.5, color: '#102844', fontWeight: 600 };

const labelStyle = {
  display: 'block',
  fontSize: 13.5,
  fontWeight: 700,
  color: '#102844',
  marginBottom: 7,
};

const inputStyle = {
  width: '100%',
  padding: '11px 14px',
  border: '1.5px solid #DEE2E6',
  borderRadius: 8,
  fontSize: 15,
  outline: 'none',
  color: '#102844',
  transition: 'border-color .18s',
};

const noteBox = {
  background: '#FFF8F0',
  border: '1px solid #F5C98A',
  borderLeft: '4px solid #FF9933',
  borderRadius: 8,
  padding: '14px 16px',
  marginTop: 20,
};

const noteItem = { fontSize: 13.5, color: '#5B4000', lineHeight: 1.6 };
